/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, useState, useEffect } from "react";

const THEMES = {
  LIGHT: "theme-light",
  DARK: "theme-dark",
};

const ThemeContext = createContext({
  theme: THEMES.LIGHT,
  toggleTheme: () => {},
});

export const ThemeProvider = ({ children }) => {
  const prefersDarkMode = window.matchMedia
    ? window.matchMedia("(prefers-color-scheme: dark)").matches
    : false;
  const [theme, setTheme] = useState(
    prefersDarkMode ? THEMES.DARK : THEMES.LIGHT
  );

  useEffect(() => {
    const changeTheme = (event) => {
      const newColorScheme = event.matches ? THEMES.DARK : THEMES.LIGHT;
      setTheme(newColorScheme);
    };

    if (window.matchMedia) {
      window
        .matchMedia("(prefers-color-scheme: dark)")
        .addEventListener("change", changeTheme);
    }

    return () => {
      if (window.matchMedia) {
        window
          .matchMedia("(prefers-color-scheme: dark)")
          .removeEventListener("change", changeTheme);
      }
    };
  }, []);

  useEffect(() => {
    setTheme(prefersDarkMode ? THEMES.DARK : THEMES.LIGHT);
  }, [prefersDarkMode]);

  const toggleTheme = () => {
    setTheme((prevTheme) =>
      prevTheme === THEMES.LIGHT ? THEMES.DARK : THEMES.LIGHT
    );
  };

  return (
    <ThemeContext value={{ theme, toggleTheme }}>
      <main className={theme}>{children}</main>
    </ThemeContext>
  );
};

export const useTheme = () => useContext(ThemeContext);
